import React from 'react'

const Services = () => {
  return (
 <div className='services'>
         <h5 className="header text-center" style={{ "font-weight": "900", "color": "#893101" }}> OUR EXCLUSIVE SERVICES</h5>
      <center>
      <div className="row mx-auto servicesRow">
             <div className="col-12 col-sm-6 col-md-4 pt-2 serviceCover">
                   <div className="d-block mx-auto border p-4 wrapper">
                        {/* <span className="fas fa-code d-block text-center"></span> */}
                        <center>                       
                              <img src="assets/data.png" alt="" className='ServicesImage' />
                              </center>
 
                        <h6 className='text-center mt-1' style={{ "font-size":"18px", "font-weight":"bold","color": "#893101" }}>  Buy Data </h6>
                        <p className='text-center'> 
                        Start enjoying this very low rates Data plan for your internet browsing databundle.
                         </p>
                         {/* <img src="assets/WebDevelopmentImage.jpeg" alt="logo" className='lmage mx-auto mr- mb-2'/>  */}
                       
                   </div>
             </div>
             <div className="col-12 col-sm-6 col-md-4 pt-2 serviceCover">
                   <div className="wrapper d-block mx-auto border p-4">
                        {/* <span className="fas fa-code d-block text-center"></span> */}
                        <center>                       
                              <img src="assets/cable sub.png" alt="" className='ServicesImage' />
                              </center>
 
                        <h6 className='text-center mt-1' style={{ "font-size":"18px", "font-weight":"bold","color": "#893101" }}>  Cable Subscription </h6>
                        <p className='text-center'> 
                        Instantly Activate Cable subscription with favourable discount compare to others.
                         </p>
                         {/* <img src="assets/WebDevelopmentImage.jpeg" alt="logo" className='lmage mx-auto mr- mb-2'/>  */}
                       
                   </div>
             </div>
             <div className="col-12 col-sm-6 col-md-4 pt-2 serviceCover">
                   <div className="wrapper d-block mx-auto border p-4">
                        {/* <span className="fas fa-code d-block text-center"></span> */}
                        <center>                       
                              <img src="assets/bulk sms.png" alt="" className='ServicesImage' />
                              </center>
 
                        <h6 className='text-center mt-1' style={{ "font-size":"18px", "font-weight":"bold","color": "#893101" }}> Bulk Sms </h6>
                        <p className='text-center'> 
                        Send BulkSMS to any number for as low as just 2.5kobo per unit
                         </p>
                         {/* <img src="assets/WebDevelopmentImage.jpeg" alt="logo" className='lmage mx-auto mr- mb-2'/>  */}
                       
                   </div>
             </div>
             <div className="col-12 col-sm-6 col-md-4 mt-2 pt-2 serviceCover">
                   <div className="wrapper d-block mx-auto border p-4">
                        {/* <span className="fas fa-code d-block text-center"></span> */}
                        <center>                       
                              <img src="assets/ultilitypa.png" alt="" className='ServicesImage' />
                              </center>
 
                        <h6 className='text-center mt-1' style={{ "font-size":"18px", "font-weight":"bold","color": "#893101" }}> Utility Payment </h6>
                        <p className='text-center'> 
                        Because we understand your needs, we have made bills and utilities payment more convenient.
                         </p>
                        
                       
                   </div>
             </div>
             <div className="col-12 col-sm-6 col-md-4 pt-2 mt-2 serviceCover ">
                   <div className="wrapper d-block mx-auto border p-4">
                        {/* <span className="fas fa-code d-block text-center"></span> */}
                        <center>                       
                              <img src="assets/airtime.png" alt="" className='ServicesImage' />
                              </center>
 
                        <h6 className='text-center mt-1' style={{ "font-size":"18px", "font-weight":"bold","color": "#893101" }}>  Airtime Topup </h6>
                        <p className='text-center'> 
                        Making an online recharge has become very easy and safe on DATAKING.
                         </p>
                         
                       
                   </div>
             </div>
       
                         
         </div>
      </center>


      <div className='services'>
      <h5 className="header text-center" style={{ "font-weight": "900", "color": "#893101","margin-top":"100px" }}>HOW IT WORKS?</h5>
      <p className="text-center" style={{ "font-size": "15px", "color":"gray" }}>Simple steps on how to use our platform.</p>
      <div className="row mx-auto servicesRow" style={{ "margin-left": "50px"}}>
             <div className="col-12 col-sm-6 col-md-4 pt-2 serviceCover"style={{"border-style":"solid", "border":"red"  }}>
                   <div className="d-block mx-auto border p-4 wrapper" style={{"border-style":"solid", "border":"red"  }}>
                 
                        {/* <span className="fas fa-code d-block text-center"></span> */}
                        <center>                       
                              <img src="assets/registerLogo.png" alt="" className='ServicesImage' />
                              </center>
 
                        <h6 className='text-center mt-1' style={{ "font-size":"18px", "font-weight":"bold","color": "#893101" }}>Register</h6>
                        <p className='text-center'> 
                        Register in few clicks. click here to begin process.
                         </p>
                         {/* <img src="assets/WebDevelopmentImage.jpeg" alt="logo" className='lmage mx-auto mr- mb-2'/>  */}
                       
                   </div>
             </div>
             <div className="col-12 col-sm-6 col-md-4 pt-2 serviceCover">
                   <div className="wrapper d-block mx-auto border p-4">
                        {/* <span className="fas fa-code d-block text-center"></span> */}
                        <center>                       
                        <img src="assets/wallet.png" alt="" className='ServicesImage' />
                              </center>
 
                        <h6 className='text-center mt-1' style={{ "font-size":"18px", "font-weight":"bold","color": "#893101" }}>Fund Wallet</h6>
                        <p className='text-center'> 
                        Credit your wallet with any of our convenient payment platform of your choice.
                         </p> 
                   </div>
             </div>
             <div className="col-12 col-sm-6 col-md-4 pt-2 serviceCover">
                   <div className="wrapper d-block mx-auto border p-4">
                        {/* <span className="fas fa-code d-block text-center"></span> */}
                        <center>                       
                              <img src="assets/services.png" alt="" className='ServicesImage' />
                              </center>
 
                        <h6 className='text-center mt-1' style={{ "font-size":"18px", "font-weight":"bold","color": "#893101" }}>Buy Services</h6>
                        <p className='text-center'> 
                        Buy any of our services with funds in your e-wallet any time any day. Your funds are safe with us.
                         </p>
                         {/* <img src="assets/WebDevelopmentImage.jpeg" alt="logo" className='lmage mx-auto mr- mb-2'/>  */}
                       
                   </div>
             </div>              
         </div>
      </div>
    </div>


  
  )
}

export default Services